<app-header></app-header>
<div class="consultancy">
    <div class="bg_img consultancy_top">
        <!-- Hamburger Menu -->
        <div class="consultancy_top_hamburger">
            <div class="hamburger-icon consultancy_top_hamburger_icon" (click)="toggleMenu()">
                <img src="../../../assets/icons/hamburger.png" alt="Menu" />
            </div>
            <div class="consultancy_top_hamburger_content" [ngClass]="{'open': isMenuOpen}">
                <div class="width-100-per consultancy_top_hamburger_content_box">
                    <div class="width-100-per">
                        <div class="bottom-border-3 cursor-pointer p-x-20 consultancy_top_hamburger_content_box_item"
                            routerLink="/patent-india">
                            <div class="p-y-18">
                                <span>Patent Service</span>
                            </div>
                        </div>
                        <div class="cursor-pointer p-x-20 consultancy_top_hamburger_content_box_item"
                            routerLink="/agro-regulatory">
                            <div class="p-y-18">
                                <span>Regulatory Service</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Page Heading -->
        <ng-container *ngFor="let heading of head">
            <div class="text-center inline_padding2 consultancy_top_content" *ngIf="heading.page === currentPage">
                <div class="inline_padding3">
                    <span class="text_style_5">Consulting Solutions</span>
                </div>
                <div class="inline_padding3 p-top-16">
                    <span class="text_black_4_res" [innerHtml]="heading.page_sub_heading"></span>
                </div>
            </div>
        </ng-container>
    </div>

    <!-- Main Content -->
    <div class="consultancy_bottom inline_padding1">
        <div class="consultancy_bottom_left">
            <ng-container *ngFor="let content of regulatoryContent">
                <div class="consultancy_bottom_content">
                    <div class="consultancy_bottom_content_box">
                        <div class="consultancy_bottom_content_box_left">
                            <img [src]="imageBaseUrl + content.image" alt="Logo"
                                class="consultancy_bottom_content_box_left_img" />
                        </div>
                        <div class="p-x-40">
                            <div>
                                <span class="text_blue_10" [innerHtml]="content.header_title"></span>
                            </div>
                            <div class="share-buttons" style="margin-top:15px;">
                                <button (click)="copyLink()"
                                    style="background: transparent; border: none; cursor: pointer;">
                                    <i class="fas fa-link" style="color: #000;"></i> <!-- Copy Link -->
                                </button>
                                <button (click)="shareViaEmail()"
                                    style="background: transparent; border: none; cursor: pointer;">
                                    <i class="fas fa-envelope" style="color: #EA4335;"></i> <!-- Email -->
                                </button>
                                <button (click)="shareViaSMS()"
                                    style="background: transparent; border: none; cursor: pointer;">
                                    <i class="fas fa-sms" style="color: #25D366;"></i> <!-- SMS -->
                                </button>
                                <button (click)="shareViaWhatsApp()"
                                    style="background: transparent; border: none; cursor: pointer;">
                                    <i class="fab fa-whatsapp" style="color: #25D366;"></i> <!-- WhatsApp -->
                                </button>
                                <button (click)="shareViaMessenger()"
                                    style="background: transparent; border: none; cursor: pointer;">
                                    <i class="fab fa-facebook-messenger" style="color: #0084FF;"></i> <!-- Messenger -->
                                </button>
                                <button (click)="shareViaViber()"
                                    style="background: transparent; border: none; cursor: pointer;">
                                    <i class="fab fa-viber" style="color: #59267C;"></i> <!-- Viber -->
                                </button>
                                <button (click)="shareViaFacebook()"
                                    style="background: transparent; border: none; cursor: pointer;">
                                    <i class="fab fa-facebook" style="color: #4267B2;"></i> <!-- Facebook -->
                                </button>
                                <button (click)="shareViaTwitter()"
                                    style="background: transparent; border: none; cursor: pointer;">
                                    <i class="fab fa-twitter" style="color: #1DA1F2;"></i> <!-- Twitter -->
                                </button>
                                <button (click)="shareViaLinkedIn()"
                                    style="background: transparent; border: none; cursor: pointer;">
                                    <i class="fab fa-linkedin" style="color: #0077B5;"></i> <!-- LinkedIn -->
                                </button>
                                <button (click)="shareViaPinterest()"
                                    style="background: transparent; border: none; cursor: pointer;">
                                    <i class="fab fa-pinterest" style="color: #E60023;"></i> <!-- Pinterest -->
                                </button>
                                <button (click)="shareViaReddit()"
                                    style="background: transparent; border: none; cursor: pointer;">
                                    <i class="fab fa-reddit" style="color: #FF4500;"></i> <!-- Reddit -->
                                </button>
                                <button (click)="shareViaTumblr()"
                                    style="background: transparent; border: none; cursor: pointer;">
                                    <i class="fab fa-tumblr" style="color: #35465C;"></i> <!-- Tumblr -->
                                </button>
                                <button (click)="shareViaTelegram()"
                                    style="background: transparent; border: none; cursor: pointer;">
                                    <i class="fab fa-telegram" style="color: #0088CC;"></i> <!-- Telegram -->
                                </button>
                                <button (click)="shareViaVK()"
                                    style="background: transparent; border: none; cursor: pointer;">
                                    <i class="fab fa-vk" style="color: #4B7BE5;"></i> <!-- VK -->
                                </button>
                                <button (click)="shareViaMix()"
                                    style="background: transparent; border: none; cursor: pointer;">
                                    <i class="fab fa-mix" style="color: #00A3E0;"></i> <!-- Mix -->
                                </button>
                                <button (click)="shareViaXing()"
                                    style="background: transparent; border: none; cursor: pointer;">
                                    <i class="fab fa-xing" style="color: #006567;"></i> <!-- Xing -->
                                </button>
                                <button (click)="shareViaLine()"
                                    style="background: transparent; border: none; cursor: pointer;">
                                    <i class="fab fa-line" style="color: #00B900;"></i> <!-- Line -->
                                </button>

                            </div>
                            <div class="p-top-16 p-r-40">
                                <p class="text_style_10" [innerHtml]="content.header_subtitle"></p>
                                <p class="text_style_9" [innerHtml]="content.header_description">
                                </p>
                            </div>
                        </div>
                    </div>

                    <!-- Content with lists -->
                    <ng-container *ngFor="let list of content.lists">
                        <div class="consultancy_bottom_content_box1" *ngIf="list.keyWords?.length">
                            <div *ngIf="list.title">
                                <span class="text_blue_10" [innerHtml]="list.title"></span>
                            </div>
                            <div class="p-top-16">
                                <ul class="checkmate-list" style="list-style: none; padding-left: 0;">
                                    <li *ngFor="let item of list.keyWords" class="text_style_10"
                                        style="background: url('../../../assets/icons/tick_icon.png') no-repeat left center; padding-left: 25px; margin-bottom: 10px;"
                                        [innerHtml]="item">
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </ng-container>

                    <!-- Additional Content Sections -->
                    <ng-container *ngFor="let section of content.body">
                        <div class="bottom_border_trans p-y-60 consultancy_bottom_content_box3 p-x-10"
                            *ngIf="section.body_title || section.body_description || section.body_keypoints?.length">
                            <div *ngIf="section.body_title">
                                <span class="text_blue_10" [innerHtml]="section.body_title"></span>
                            </div>
                            <div class="text_style_10 p-top-16 text_align-justify" *ngIf="section.body_description">
                                <span [innerHtml]="section.body_description"></span>
                            </div>

                            <div class="p-top-16 consultancy_bottom_content_box3_body3 "
                                *ngIf="section.body_keypoints?.length">
                                <ul class="f-16 row consultancy_bottom_content_box3_body3_item3">
                                    <li class="consultancy_bottom_content_box3_body3_item3_list3 p-top-40"
                                        *ngFor="let item of section.body_keypoints">
                                        <img *ngIf="item.keypoints_icon" [src]="imageBaseUrl + item.keypoints_icon"
                                            alt="{{ item.keypoints_title }}" class="item-icon" />
                                        <div class="item-content">
                                            <strong class="text_blue_1" *ngIf="item.keypoints_title"
                                                [innerHtml]="item.keypoints_title"></strong>
                                            <p class="text_style_1 text_align-justify "
                                                *ngIf="item.keypoints_description"
                                                [innerHtml]="item.keypoints_description"></p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </ng-container>
        </div>

        <!-- Brochure Download Section -->
        <div class="consultancy_bottom_right">
            <div class="consultancy_bottom_right_sticky">
                <div class="edit_body_heading width-100-per left-border-2">
                    <div class="width-100-per">
                        <div class="cursor-pointer p-x-20" routerLink="/patent-india">
                            <div class="p-y-18">
                                <span class="text_black_11">Patent Service</span>
                            </div>
                        </div>
                        <div class="cursor-pointer p-x-20 left-border-1 m-r-3-neg" routerLink="/agro-regulatory">
                            <div class="p-y-18">
                                <span class="text_blue_18">Regulatory Service</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-top-40">
                    <div class="bg_1 border_box border-radius-10">
                        <div class="bottom_border_trans p-x-20 p-top-32 p-bot-16">
                            <span class="text_blue_1">Download Brochure</span>
                        </div>
                        <div>
                            <ng-container *ngFor="let pdf of pdfFiles">
                                <div class="p-y-24 p-x-20 dis-flex-7 bottom_border_trans">
                                    <div>
                                        <img src="../../../assets/icons/pdf_icon.png" />
                                    </div>
                                    <div class="p-l-8">
                                        <a [href]="pdf.url" target="_blank"
                                            class="text_blue_2 text_decoration_none word-break">{{ pdf.file_name }}</a>
                                    </div>
                                </div>
                            </ng-container>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>